/** Org-admin retention-policy editor — Phase 2B-ui.
 *
 * Notification templates moved to /admin/branding (it's user-visible
 * copy customisation, sibling to logo + colour overrides). SMS opt-in
 * moved to /admin/settings (it's an org-wide preference toggle).
 */
import { useTranslation } from "react-i18next";

import { AppLayout } from "@/components/AppLayout";
import { PermissionGate } from "@/components/PermissionGate";
import {
  RetentionDeletionLogCard,
  RetentionPolicyCard,
} from "@/modules/admin";


export default function AdminRetentionPage() {
  const { t } = useTranslation();
  return (
    <AppLayout
      title={t("admin.retention.pageTitle")}
      description={t("admin.retention.pageDescription")}
    >
      <PermissionGate
        perm="retention.update"
        fallback={
          <p className="card text-sm text-nb-text-2">{t("admin.noPermission")}</p>
        }
      >
        <div className="space-y-4">
          <RetentionPolicyCard />
          <RetentionDeletionLogCard />
        </div>
      </PermissionGate>
    </AppLayout>
  );
}
